<template>
    <main>
        <div id="content">
            <div slot="breadcrumb" class="mb-4 d-flex align-items-center" id="breadcrumb">
                <router-link :to="{ name: 'Setting' }">Setting</router-link>
                <i class="dripicons-chevron-right mr-1 ml-1 pt-1"></i>
                <span class="active">Info</span>
            </div>
            <div class="white-frame-2">
                <b-card no-body class="no-border-radius border-0">
                    <basic-settings></basic-settings>
                </b-card>
            </div>
        </div>
    </main>
</template>

<script>
  import BasicSettings from './Basic/BasicSettings';

  export default {
    data() {
      return {
        form: {}
      };
    },
    components: {
      BasicSettings
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Setting/Setting.vue